import { customerMarketShopfrontApi, Site } from '@envato/foundation-types'
import get from 'lodash-es/get'
import * as React from 'react'
import { RouterAction } from 'react-router-redux'

import { ILocationParams } from '../../../common/reducers/reactRouterLocation'
import ElementsBanner from '../../components/elementsBanner'
import ToggleFilterButton from '../../components/filters/filterGroup/toggleButtonContainer'
import SearchFiltersContainer from '../../components/filters/searchFiltersContainer'
import SelectedFilters from '../../components/filters/selectedFilters'
import LoadingSpinner from '../../components/icons/loadingSpinner'
import LayoutSwitcher from '../../components/layoutSwitcher'
import PlaceitBanner from '../../components/placeitBanner'
import SortByDropdown from '../../components/sortBy/sortBy'
import UsDollarsNoticeContainer from '../../components/usDollarsNotice/usDollarsNoticeContainer'
import RelatedSearches from './result/relatedSearches'
import SearchNoResults from './result/searchNoResults'
import SearchResults from './result/searchResults'

import * as styles from './searchContentSection.module.css'

interface IProps {
  searchResultsViewType: string
  baseUrl: string
  results: customerMarketShopfrontApi.search.IResult
  location: any
  loading: boolean
  currentSite: Site
  relatedSearches?: any
  push: (path: string) => RouterAction
  experiments: any
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  toggleSidebar: () => void
}

class SearchContentSection extends React.Component<IProps> {
  private activeFiltersCount: number = 0

  public render() {
    const {
      searchResultsViewType,
      baseUrl,
      results,
      location,
      loading,
      currentSite,
      relatedSearches,
      push,
      experiments,
      locationParams,
      makeSearchLink,
      toggleSidebar
    } = this.props

    const totalHits = results.total_hits
    const aggregations = get(results, 'aggregations') || {}
    const didYouMeanByTerms = get(results, 'suggestions') || []
    const matches = results.matches
    const haveResults = !!(matches && matches.length)
    const shouldShowRecommendedSearches =
      !loading && relatedSearches && relatedSearches.recommendations.length > 0

    const updateActiveFiltersCount = (count: number) => {
      this.activeFiltersCount = count
    }

    const shouldShowElementsPromotionBanner =
      haveResults && currentSite === Site.themeforest
    const shouldShowPlaceitPromotionBanner =
      haveResults &&
      (currentSite === Site.graphicriver || currentSite === Site.videohive)

    const SearchResultsComponent = (
      <div className={styles.searchResultsWrapper}>
        <SearchResults
          baseUrl={baseUrl}
          results={results}
          location={location}
          currentSite={currentSite}
          locationParams={locationParams}
          makeSearchLink={makeSearchLink}
        />
      </div>
    )

    const resultsContainer = haveResults ? (
      SearchResultsComponent
    ) : (
      <SearchNoResults
        locationParams={locationParams}
        didYouMeanByTerms={didYouMeanByTerms}
      />
    )

    const loadingContainer = (
      <div className={styles.loadingContainer}>
        <LoadingSpinner />
      </div>
    )

    return (
      <div className={styles.searchContentSection} id="content">
        <div className={styles.searchControls}>
          <ToggleFilterButton
            id="filterGroup"
            activeFiltersCount={this.activeFiltersCount}
          />
          <div className={styles.searchResultHeader}>
            <div className={styles.headerRightSideContainer}>
              <div className={styles.headerRightSide}>
                <LayoutSwitcher
                  locationParams={locationParams}
                  currentSite={currentSite}
                  currentView={searchResultsViewType}
                  hideLayoutSwitchOnMobile
                />

                <SortByDropdown
                  push={push}
                  currentSite={currentSite}
                  location={location}
                  locationParams={locationParams}
                  makeSearchLink={makeSearchLink}
                  experiments={experiments}
                />
              </div>
            </div>
          </div>
          <UsDollarsNoticeContainer styleClassName={styles.gstMessage} />
        </div>
        <div className={styles.searchResults}>
          <SearchFiltersContainer
            totalHits={totalHits}
            currentSite={currentSite}
            aggregations={aggregations}
            locationParams={locationParams}
            makeSearchLink={makeSearchLink}
            loading={loading}
            location={location}
            experiments={experiments}
            toggleSidebar={toggleSidebar}
            updateActiveFiltersCount={updateActiveFiltersCount}
          />
          <div className={styles.searchResultsBody}>
            <SelectedFilters
              totalHits={totalHits}
              term={locationParams.term}
              loading={loading}
              locationParams={locationParams}
              categories={aggregations.category}
              currentSite={currentSite}
            />

            {loading ? loadingContainer : resultsContainer}
            {shouldShowRecommendedSearches && (
              <RelatedSearches {...relatedSearches} />
            )}
            {shouldShowElementsPromotionBanner && (
              <ElementsBanner currentSite={currentSite} />
            )}
            {shouldShowPlaceitPromotionBanner && (
              <PlaceitBanner currentSite={currentSite} />
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default SearchContentSection
